import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';
import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';

const AsyncPromoPage = async(() =>
  import('@xanadu/ui-shared/components/PromoPage').then(module => module.default)
);

function RouteHandler({
  match: {
    params: {
      promoUrl = 'default'
    }
  }
}) {
  const {
    customization: {
      PromoPage: {
        joinText = 'Join Now',
        trustPilotTitle = '',
        renderPartnerLogos = null,
      } = {},
    } = {},
  } = useContext(ChildrenPropsContext) || {};

  return (
    <AsyncPromoPage
      promoUrl={promoUrl}
      joinText={joinText}
      trustPilotTitle={trustPilotTitle}
      renderPartnerLogos={renderPartnerLogos}
    />
  );
}

RouteHandler.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      promoUrl: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(RouteHandler);
